import { AsyncPipe } from '@angular/common';
import { AuthenticationFacade, UserFacade } from '@ebeihilfe/core';
import { ChangeDetectionStrategy, Component, OnInit, Signal, inject } from '@angular/core';
import { LogoSvgComponent } from '@ebeihilfe/web-shared/web-svgs/logo/logo.component';
import { Observable } from 'rxjs';
import { PortalToolbarComponent } from '../portal-toolbar/portal-toolbar.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [AsyncPipe, LogoSvgComponent, PortalToolbarComponent, TranslateModule],
  selector: 'portal-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  private readonly user: UserFacade = inject(UserFacade);
  private readonly authFacade: AuthenticationFacade = inject(AuthenticationFacade);

  public personalNumber: Signal<string>;
  public isAuthenticated: Observable<boolean>;

  public ngOnInit(): void {
    this.isAuthenticated = this.authFacade.authenticationChange$;
    this.personalNumber = this.user.username;
  }
}
